import * as React from 'react';
export const rollupsSvg = React.forwardRef(function rollupsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 11.032a4.968 4.968 0 1 0 3.776 8.196l4.754 5.212c-.24.243-.49.476-.75.697l-4.492-4.925 3.381 5.766a11.82 11.82 0 0 1-.986.594l-3.073-5.24 1.94 5.776c-.412.169-.835.316-1.269.439l-1.636-4.87.588 5.117c-.477.09-.965.15-1.46.182l-.516-4.489L15.851 28a12.084 12.084 0 0 1-1.594-.125l.352-3.914-1.184 3.763a11.901 11.901 0 0 1-1.657-.49l.998-3.17-1.655 2.899a11.976 11.976 0 0 1-1.63-.886l1.307-2.29-1.755 1.986A12.055 12.055 0 0 1 7.52 24.49l1.417-1.604-1.74 1.27a12.05 12.05 0 0 1-1.294-1.669l1.051-.767-1.19.546A11.945 11.945 0 0 1 4 16C4 9.373 9.373 4 16 4v7.032Zm10.051 11.526c-.163.25-.336.494-.517.731l-5.728-4.097a4.95 4.95 0 0 0 .512-.735l5.733 4.101Zm1.106-2.13a11.96 11.96 0 0 1-.306.704l-6.444-2.837a5.01 5.01 0 0 0 .301-.706l6.449 2.84Zm.666-2.365c-.036.211-.078.42-.126.627l-6.906-1.374c.056-.204.1-.413.129-.626l6.903 1.373Zm.174-2.346a12.182 12.182 0 0 1 .001.48h-7.034a4.926 4.926 0 0 0-.005-.48h7.038Zm-.284-2.336c.03.135.058.27.084.407l-6.9 1.373a5.015 5.015 0 0 0-.087-.407l6.903-1.373Zm-.735-2.234c.056.126.11.254.162.383l-6.5 2.692a4.953 4.953 0 0 0-.165-.382l6.503-2.693ZM25.818 9.1c.08.113.159.228.234.344l-5.848 3.908a4.98 4.98 0 0 0-.237-.342L25.82 9.1Zm-1.533-1.78c.1.095.2.193.296.292l-4.973 4.973a4.97 4.97 0 0 0-.298-.29l4.976-4.975Zm-1.782-1.406c.117.075.232.152.345.231l-3.908 5.85a4.995 4.995 0 0 0-.345-.232l3.908-5.85Zm-2.09-1.076c.129.051.257.104.384.16l-2.693 6.501a4.935 4.935 0 0 0-.384-.16l2.693-6.501Zm-2.261-.645c.137.025.273.052.408.081l-1.373 6.902a4.922 4.922 0 0 0-.408-.082l1.373-6.9Z',
      fill: '#2A5D33',
    }),
  );
});
rollupsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rollups = {
  category: 'brand',
  colorable: false,
  name: 'rollups',
  svg: rollupsSvg,
};
